import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { I18n } from 'components';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const FormGroupFillStatus = ({ progress, total }) => {
  if (!progress) {
    return (
      <div className={cx('notFilled')}>
        <I18n path="settings.userForm.notFilled" />
      </div>
    );
  }

  if (progress === total) {
    return (
      <div className={cx('filled')}>
        <I18n path="settings.userForm.filled" />
      </div>
    );
  }

  return (
    <div className={cx('partiallyFilled')}>
      <I18n
        path="settings.userForm.partiallyFilled"
        vars={{ progress, total }}
      />
    </div>
  );
};

export default FormGroupFillStatus;

FormGroupFillStatus.propTypes = {
  progress: PropTypes.number,
  total: PropTypes.number,
};
